import {Flex} from "@chakra-ui/react";
import Bell from "./Bell";
import React, {useState} from "react";

function BellSetup() {

    return (
        <Flex direction='column' pt={{base: "120px", md: "75px"}}>
            <Bell
                title={"Bell Setup"}
                captions={["SN", "Bell Name","Type", "Music","Enabled", "Created Date", "Status", ""]}
            />
        </Flex>
    );
}

export default BellSetup;